import type { ReactNode } from 'react'
import { Button, Modal } from '@/ui'

/** A modal form with Cancel / Save. `onSave` returns a promise; the dialog closes when it resolves. */
export function FormDialog({
  open,
  onClose,
  title,
  description,
  children,
  saveLabel = 'Save',
  loading,
  canSave = true,
  onSave,
  tone = 'primary',
}: {
  open: boolean
  onClose: () => void
  title: ReactNode
  description?: ReactNode
  children: ReactNode
  saveLabel?: string
  loading?: boolean
  canSave?: boolean
  onSave: () => Promise<unknown> | void
  tone?: 'primary' | 'danger'
}) {
  const save = async () => {
    try {
      await onSave()
      onClose()
    } catch {
      /* the mutation toasts the server's message */
    }
  }
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={title}
      description={description}
      dismissible={!loading}
      footer={
        <>
          <Button variant="ghost" className="ml-auto" onClick={onClose} disabled={loading}>
            Cancel
          </Button>
          <Button variant={tone} loading={loading} disabled={!canSave} onClick={() => void save()}>
            {saveLabel}
          </Button>
        </>
      }
    >
      <form
        className="flex flex-col gap-4"
        onSubmit={(e) => {
          e.preventDefault()
          if (canSave) void save()
        }}
      >
        {children}
        <button type="submit" hidden aria-hidden="true" tabIndex={-1} />
      </form>
    </Modal>
  )
}
